import type { ReactNode } from 'react'

import { Button } from '~/elements/Button'
import { Dialog, DialogFooter, DialogTitle } from '~/elements/Dialog'

export function ConfirmBillingDialog({
  open,
  onOpenChange,
  title,
  description,
  confirmLabel,
  onConfirm,
  loading,
  danger
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: ReactNode
  description: ReactNode
  confirmLabel: ReactNode
  onConfirm: () => Promise<unknown>
  loading?: boolean
  danger?: boolean
}) {
  return (
    <Dialog className="gap-5" onOpenChange={onOpenChange} open={open}>
      <DialogTitle className="pr-8">{title}</DialogTitle>
      <div className="flex flex-col gap-2 text-sm text-content2">{description}</div>
      <DialogFooter className="mt-2 bg-transparent">
        <Button disabled={loading} onClick={() => onOpenChange(false)} variant="secondary">
          Cancel
        </Button>
        <Button
          loading={loading}
          onClick={() =>
            onConfirm()
              .then(() => onOpenChange(false))
              .catch(() => undefined)
          }
          variant={danger ? 'danger' : 'primary'}
        >
          {confirmLabel}
        </Button>
      </DialogFooter>
    </Dialog>
  )
}
